(() => {
  const root = document.documentElement;
  const storageKey = 'iine-color-mode';
  const colorSchemeQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: light)') : null;
  const isTrackingPage = /(?:^|\/)apps\/track-order\/?$/i.test(window.location.pathname);
  const trackingPageThemeStyleId = 'iine-track-order-color-mode';
  const trackingPageThemeCss = `
    :host([data-iine-theme="dark"]) [data-17track-root] {
      --color-text: #f5f5f6 !important;
      --yq-detected-text: #f5f5f6 !important;
      --color-text-muted: #aaaab0 !important;
      --yq-detected-muted: #aaaab0 !important;
      --color-surface: #1f1f23 !important;
      --color-border: rgba(255, 255, 255, 0.14) !important;
      --color-border-soft: rgba(255, 255, 255, 0.12) !important;
      --color-bg: #111114 !important;
      --color-bg-base: #111114 !important;
      --color-bg-base-rgb: 17, 17, 20 !important;
      --yq-detected-root-bg: #111114 !important;
      --yq-detected-bg: #111114 !important;
      --yq-detected-bg-rgb: 17, 17, 20 !important;
      background: #111114 !important;
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] > :is(
      [data-17track="query-section"],
      [data-17track="image-section"],
      [data-17track="video-section"],
      [data-17track="brand-story-section"],
      [data-17track="faq-section"]
    ) {
      background-color: #111114 !important;
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-section"] [data-yq-query-surface] {
      background: #1f1f23 !important;
      border-color: rgba(255, 255, 255, 0.12) !important;
      box-shadow: 0 18px 45px rgba(0, 0, 0, 0.28) !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-tabs"] {
      background: #28282c !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-tabs"] :is(
      button.active,
      button[aria-selected="true"]
    ) {
      background: #17171a !important;
      color: #ffffff !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-section"] input {
      background: #28282c !important;
      border-color: rgba(255, 255, 255, 0.14) !important;
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-section"] input::placeholder {
      color: #8f8f96 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-section"] button:not(.active) {
      color: #b8b8be !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-section"] button[data-17track="query-button"] {
      color: #ffffff !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="query-section"] :is(
      .custom-dropdown .dropdown-trigger,
      .dropdown-menu,
      [data-17track="language-dropdown-menu"]
    ) {
      background: #28282c !important;
      border-color: rgba(255, 255, 255, 0.12) !important;
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      .yq-t-section-title,
      .yq-t-faq-question,
      .yq-t-faq-support-title,
      .yq-story-text h2,
      .brand-story-content
    ) {
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      .yq-t-section-subtitle,
      .yq-t-faq-answer,
      .brand-story-content p
    ) {
      color: #aaaab0 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] .yq-t-gallery-item {
      background: #1f1f23 !important;
      border-color: rgba(255, 255, 255, 0.08) !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      [data-17track="image-section"],
      [data-yq-slot-rendered="image-section"]
    ) {
      --yq-media-card-bg: #1f1f23 !important;
      --yq-media-card-border: rgba(255, 255, 255, 0.08) !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] .yq-t-video-frame {
      background: #1c1719 !important;
      border-color: rgba(217, 9, 41, 0.24) !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      [data-17track="video-section"],
      [data-yq-slot-rendered="video-section"]
    ) {
      --yq-video-frame-bg: #1c1719 !important;
      --yq-video-placeholder-bg: #28282c !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] .yq-story-media {
      background: #28282c !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] .yq-story-tag {
      background: #242428 !important;
      border-color: rgba(255, 255, 255, 0.1) !important;
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track="brand-story-section"] [data-17track="brand-story-text"] {
      color: #aaaab0 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      .yq-t-faq-block,
      .yq-t-faq-item,
      .yq-t-faq-question
    ) {
      border-color: rgba(255, 255, 255, 0.12) !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] .yq-t-faq-support {
      background: rgba(217, 9, 41, 0.12) !important;
      border-color: rgba(217, 9, 41, 0.28) !important;
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      [data-17track="faq-section"],
      [data-yq-slot-rendered="faq-section"]
    ) {
      --yq-faq-divider: rgba(255, 255, 255, 0.12) !important;
      --yq-faq-muted: #aaaab0 !important;
      --yq-faq-support-bg: rgba(217, 9, 41, 0.12) !important;
      --yq-faq-support-border: rgba(217, 9, 41, 0.28) !important;
      --yq-faq-support-text: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      [data-17track="query-result-section"],
      [data-yq-slot-rendered="query-result-section"]
    ) {
      --yq-slot-surface: #1f1f23 !important;
      --yq-slot-border: rgba(255, 255, 255, 0.12) !important;
      --yq-slot-muted: #aaaab0 !important;
      --yq-slot-shadow: 0 18px 45px rgba(0, 0, 0, 0.28) !important;
      --yq-progress-track-soft: rgba(255, 255, 255, 0.08) !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      .yq-t-translation-control .dropdown-trigger,
      .yq-t-carrier-cell
    ) {
      background: #28282c !important;
      border-color: rgba(255, 255, 255, 0.12) !important;
      color: #f5f5f6 !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] :is(
      [data-17track="product-recommendation-section"],
      [data-yq-slot-rendered="product-recommendation-section"]
    ) {
      --yq-recs-card-bg: #1f1f23 !important;
      --yq-recs-media-bg: #28282c !important;
      --yq-recs-body-bg: #1f1f23 !important;
      --yq-recs-secondary-hover-bg: rgba(255, 255, 255, 0.08) !important;
    }

    :host([data-iine-theme="dark"]) [data-17track-root] .yq-t-recs-nav {
      background: #28282c !important;
      border-color: rgba(255, 255, 255, 0.12) !important;
      color: #f5f5f6 !important;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.24) !important;
    }
  `;
  let trackingPageThemeScheduled = false;

  const syncTrackingPageTheme = () => {
    if (!isTrackingPage) return true;
    const trackingPage = document.querySelector('#yq-ai-trackpage');
    const trackingRoot = trackingPage?.shadowRoot;
    if (!trackingPage || !trackingRoot) return false;

    let themeStyle = trackingRoot.getElementById(trackingPageThemeStyleId);
    if (!themeStyle) {
      themeStyle = document.createElement('style');
      themeStyle.id = trackingPageThemeStyleId;
      themeStyle.textContent = trackingPageThemeCss;
      trackingRoot.append(themeStyle);
    }
    trackingPage.dataset.iineTheme = root.dataset.iineTheme === 'light' ? 'light' : 'dark';
    return true;
  };

  const scheduleTrackingPageTheme = () => {
    if (!isTrackingPage || trackingPageThemeScheduled) return;
    trackingPageThemeScheduled = true;
    [0, 100, 250, 500, 1000, 2000, 4000, 8000, 12000].forEach((delay) => {
      window.setTimeout(syncTrackingPageTheme, delay);
    });
  };

  const hasSavedMode = () => {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return saved === 'light' || saved === 'dark';
    } catch (error) {
      return false;
    }
  };

  const setMode = (requestedMode, persist = true) => {
    const mode = requestedMode === 'light' ? 'light' : 'dark';
    root.dataset.iineTheme = mode;
    root.style.colorScheme = mode;
    syncTrackingPageTheme();
    if (persist) {
      try {
        window.localStorage.setItem(storageKey, mode);
      } catch (error) {
        // Storage can be unavailable in privacy mode; the current page still updates.
      }
    }
    document.querySelectorAll('[data-iine-theme-value]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.iineThemeValue === mode));
    });
  };

  const closeMarketMenus = (exception) => {
    document.querySelectorAll('[data-iine-header-market] details[open]').forEach((details) => {
      if (!exception || !details.contains(exception)) details.removeAttribute('open');
    });
  };

  const loadIineNavigationImages = (menuItem) => {
    menuItem?.querySelectorAll('[data-iine-nav-image]').forEach((image) => {
      const src = image.dataset.iineNavSrc;
      if (!src || image.dataset.iineNavLoading === 'true') return;
      image.dataset.iineNavLoading = 'true';

      const fullImage = new Image();
      fullImage.decoding = 'async';
      fullImage.fetchPriority = 'high';
      fullImage.sizes = image.sizes;
      let revealed = false;

      const revealFullImage = () => {
        if (revealed || !fullImage.naturalWidth) return;
        revealed = true;
        if (image.dataset.iineNavSrcset) image.srcset = image.dataset.iineNavSrcset;
        image.src = src;
        image.removeAttribute('data-iine-nav-src');
        image.removeAttribute('data-iine-nav-srcset');
        delete image.dataset.iineNavLoading;
      };

      fullImage.addEventListener('load', () => {
        if (typeof fullImage.decode === 'function') fullImage.decode().catch(() => {}).finally(revealFullImage);
        else revealFullImage();
      }, { once: true });
      fullImage.addEventListener('error', () => {
        delete image.dataset.iineNavLoading;
      }, { once: true });

      if (image.dataset.iineNavSrcset) fullImage.srcset = image.dataset.iineNavSrcset;
      fullImage.src = src;
      if (fullImage.complete && fullImage.naturalWidth) revealFullImage();
    });
  };

  const warmIineNavigationFromEvent = (event) => {
    loadIineNavigationImages(event.target.closest?.('.iine-navigation__menu-item'));
  };

  document.addEventListener('pointerover', warmIineNavigationFromEvent, { capture: true, passive: true });
  document.addEventListener('pointerdown', warmIineNavigationFromEvent, { capture: true, passive: true });
  document.addEventListener('touchstart', warmIineNavigationFromEvent, { capture: true, passive: true });
  document.addEventListener('focusin', warmIineNavigationFromEvent, true);

  document.addEventListener('click', (event) => {
    const themeButton = event.target.closest('[data-iine-theme-value]');
    if (themeButton) {
      setMode(themeButton.dataset.iineThemeValue);
      return;
    }
    closeMarketMenus(event.target);
  });

  const syncCurrencyFromCountry = (countrySelect) => {
    if (!countrySelect) return;
    const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    const form = countrySelect.closest('.iine-header-market__form');
    const currencySelect = form?.querySelector('[data-iine-currency-select]');
    if (!selectedCountry || !currencySelect) return;
    const currencyCode = selectedCountry.dataset.currencyCode || '';
    if ([...currencySelect.options].some((option) => option.value === currencyCode)) {
      currencySelect.value = currencyCode;
    }
  };

  const syncCountryFromCurrency = (currencySelect) => {
    if (!currencySelect) return;
    const form = currencySelect.closest('.iine-header-market__form');
    const countrySelect = form?.querySelector('[data-iine-country-select]');
    const selectedCurrency = currencySelect.options[currencySelect.selectedIndex];
    if (!countrySelect || !selectedCurrency) return;

    const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    if (selectedCountry?.dataset.currencyCode === currencySelect.value) return;

    const representativeCountry = selectedCurrency.dataset.countryCode;
    if ([...countrySelect.options].some((option) => option.value === representativeCountry)) {
      countrySelect.value = representativeCountry;
    }
  };

  document.addEventListener('change', (event) => {
    const countrySelect = event.target.closest('[data-iine-country-select]');
    if (countrySelect) {
      syncCurrencyFromCountry(countrySelect);
      return;
    }

    const currencySelect = event.target.closest('[data-iine-currency-select]');
    if (currencySelect) syncCountryFromCurrency(currencySelect);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.iine-header-market__form');
    if (!form) return;
    syncCountryFromCurrency(form.querySelector('[data-iine-currency-select]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMarketMenus();
      const openSearchClose = document.querySelector('.header-search-content:not(.hidden) .iine-header-search__close');
      if (openSearchClose) openSearchClose.click();
    }
  });

  const initialize = () => {
    setMode(root.dataset.iineTheme || 'dark', false);
    scheduleTrackingPageTheme();
    document.querySelectorAll('[data-iine-country-select]').forEach(syncCurrencyFromCountry);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.addEventListener('load', initialize, { once: true });
  colorSchemeQuery?.addEventListener?.('change', (event) => {
    if (!hasSavedMode()) setMode(event.matches ? 'light' : 'dark', false);
  });
})();
